import {
  Alert,
  AlertIcon,
  AlertTitle,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  useToast,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useUsers } from "../../store/user/reducer";
import { REQUEST_DELETE_USER } from "../../store/user/userActionType";
import { IUser } from "../../types/user";
interface Props {
  user: IUser;
  isOpen: any;
  onClose: any;
}
const UserDeleteConfirmation: React.FC<Props> = ({ isOpen, onClose, user }) => {
  const dispatch = useDispatch();
  const { users, busy, message } = useUsers();
  const { _id } = user;
  const toast = useToast();

  useEffect(() => {
    const findLink = users.find((val: Record<string, any>) => val._id === _id);
    if (!findLink) {
      toast({
        title: "Deleted",
        description: "User is successfully deleted.",
        status: "info",
        isClosable: true,
        position: "top-right",
      });
      onClose();
    }
  }, [_id, users, onClose, toast]);
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete User</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            Are you sure to delete this User? {user.email}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_USER,
                payload: { _id: user._id },
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>{" "}
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};
export default UserDeleteConfirmation;
